import React, { useState, useEffect } from "react";
import { Navigate , useNavigate  } from "react-router-dom";
import Swal from "sweetalert2";
import ApiService from "../util/ApiService"; // Para redirecionar a rota
import LoadingScreen from "../util/LoadingScreen";
import { CCollapse } from "@coreui/react";
import AuthService from "../login/AuthService"; // Importando o AuthService para obter os dados do usuário

const PrivateTab = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [radius, setRadius] = useState(50); // Define um valor inicial padrão
    const [collapseState, setCollapseState] = useState({
        collapseThree: false,
    });
    const [users, setUsers] = useState(AuthService.getUserData()); // Obtendo dados do usuário
    const history = useNavigate();

    // Carregar o valor do radius de users.distance
    useEffect(() => {
        if (users && users.distance) {
            setRadius(users.distance); // Define o valor de users.distance como o raio
        }
    }, [users]);

    // Função para inativar a conta
    const inactivate = async () => {
        try {
            const result = await Swal.fire({
                title: 'Tem certeza?',
                text: "Você poderá reverter isso efetuando login novamente.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, inativar!',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                setIsLoading(true);
                // Chamando a API para inativar o usuário
                const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "users/inactivate", {}, true);
                if (response.code === 200) {
                    setIsLoading(false);
                    Swal.fire({
                        title: 'Sucesso!',
                        text: 'Conta inativada com sucesso.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then(() => {
                           window.location.href = "/admin/logout";
                    });
                } else {
                    setIsLoading(false);
                    throw new Error('Falha ao inativar conta');
                }
            }
        } catch (error) {
            setIsLoading(false);
            ApiService.handleApiError(error);
        }
    };

    // Função para alternar a visibilidade do colapso
    const toggleCollapse = (collapseKey) => {
        setCollapseState((prevState) => ({
            ...prevState,
            [collapseKey]: !prevState[collapseKey]
        }));
    };

    // Função para manipular a alteração no raio
    const handleRadiusChange = (e) => {
        setRadius(e.target.value);
    };

    // Função para enviar o valor atualizado de raio para a API e salvar no localStorage
    const updateRadius = async () => {
        setIsLoading(true);
        try {
            const response = await ApiService.send("put", process.env.REACT_APP_URL_API + "users/distance", { distance: radius }, true);
            if ([200, 201].includes(response.status)) {
                // Atualiza o radius no localStorage
                const updatedUser = { ...users, distance: radius };

                // Atualiza o localStorage corretamente
                const storedData = localStorage.getItem('users');
                const parsedData = storedData ? JSON.parse(storedData) : {};
                const updatedData = { ...parsedData, data: { ...parsedData.data, user: updatedUser } };
                localStorage.setItem('users', JSON.stringify(updatedData));

                setUsers(updatedUser); // Atualiza o estado com o novo valor

                setIsLoading(false);
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Distância de notificação atualizada com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            } else {
                throw new Error('Falha ao atualizar a distância');
            }
        } catch (error) {
            setIsLoading(false);
            ApiService.handleApiError(error);
        }
    };

    return (
        <div id="privacy_tab" className="tab-pane fade">
            {isLoading && <LoadingScreen />}


                <div className="card-body">
                    <h5 className="card-title">Configurações de Privacidade</h5>
                    <div className="row mt-4">
                        <div className="col-md-12 col-lg-12">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <p className="mb-0">Inativar minha conta</p>
                                    <small className="text-muted">
                                        Sua conta será inativada, e você poderá reativá-la a qualquer momento.
                                    </small>
                                </div>
                                <button type="button" className="btn btn-warning"  onClick={() =>inactivate}>
                                    Inativar
                                </button>
                            </div>

                            {/*<hr/>*/}
                            {/*<div className="d-flex justify-content-between align-items-center mb-3">*/}
                            {/*    <div>*/}
                            {/*        <p className="mb-0">Distância: {radius} km</p>*/}
                            {/*        <small className="text-muted">*/}
                            {/*            Distância da sua localização, para receber notificações de plantão.*/}
                            {/*        </small>*/}
                            {/*        <p>*/}
                            {/*            <input*/}
                            {/*                type="range"*/}
                            {/*                className="form-range"*/}
                            {/*                value={radius}*/}
                            {/*                onChange={handleRadiusChange}*/}
                            {/*                min="0"*/}
                            {/*                max="300"*/}
                            {/*            />*/}
                            {/*        </p>*/}
                            {/*    </div>*/}
                            {/*    <button className="btn btn-primary mt-2" onClick={updateRadius}>*/}
                            {/*        Atualizar Distância*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                        </div>

                </div>
            </div>
        </div>
    );
};

export default PrivateTab;
